import React, { useReducer } from 'react'
import JustContext from './justContext'
import JustReducer from './justReducer'
import { apiCall } from '../../../common/api'
import { response } from '../../common'
import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_CARDS,
    GET_CHARITY_DETAILS,
    GET_CHARITY_DETAILS_BY_ID,
} from './justTypes'

const JustState = (props) => {
    const initialState = {
        responseStatus: null,
        all_cards: null,
        all_charity_details: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        all_charity_details_by_id: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
    }

    const [state, dispatch] = useReducer(JustReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const payCart = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'justgiving_payment', formData, '', 'payment'),
            ])
            resp.commonResponse(res.data, 'payment')
        } catch (err) {
            resp.commonErrorResponse('payment')
        }
    }

    const getAllCharityDetails = async (formData, froms = 'justgiving_charity') => {
        const from = froms
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getCharity', formData, '', 'paymentThird/justgiving'),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_CHARITY_DETAILS,
                    payload: {
                        records: res.data.data.responseData?.GroupedResults?.Results?.length
                            ? res.data.data.responseData.GroupedResults.Results
                            : [],
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const getAllCharityDetailsById = async (formData, froms = 'justgiving_charity') => {
        const from = froms
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getCharityById', formData, '', 'paymentThird/justgiving'),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_CHARITY_DETAILS_BY_ID,
                    payload: {
                        records: res.data?.data?.responseData?.length
                            ? res.data.data.responseData
                            : [],
                        // totalRecords: res.data.data.responseData.totalRecords,
                        // setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                dispatch({
                    type: GET_CHARITY_DETAILS_BY_ID,
                    payload: {
                        records: res.data?.data?.responseData?.length
                            ? res.data.data.responseData
                            : [],
                        // totalRecords: res.data.data.responseData.totalRecords,
                        // setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const payResponse = async (formData) => {
        const from = 'justgiving_response'
        try {
            const [res] = await Promise.all([apiCall('post', from, formData, '', 'payment')])
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <JustContext.Provider
            value={{
                responseStatus: state.responseStatus,
                all_cards: state.all_cards,
                all_charity_details: state.all_charity_details,
                all_charity_details_by_id: state.all_charity_details_by_id,
                payCart,
                payResponse,
                clearResponse,
                getAllCharityDetails,
                getAllCharityDetailsById,
            }}
        >
            {props.children}
        </JustContext.Provider>
    )
}

export default JustState
